export const selectSearchState = state => state.searchState;
export const selectSearchQuery = state => state.searchState.query;
export const selectSearchStatus = state => state.searchState.status;
export const selectSearchResults = state => state.searchState.results;